export const PRODUCT_NAME = 'MAINTENANCE READY™'
export const OFFER_ANCHOR = '#offer'
export const CHECKOUT_URL = 'https://maintenance-ready.impultienda.ar/checkout'
export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/kTnyjPDiXkyk4kGCHrSpYA/Diseno-sin-titulo-7-2.webp'
